<template>
  <BittsInput
    ref="input"
    v-model="proxyUrl"
    class="c-salesforce-proxy-url-field"
    name="salesforce-proxy-url"
    data-testid="salesforce-proxy-url"
    form-label="Proxy URL"
    placeholder="https://sf-proxy.acme.com"
    :status="status"
    :danger-text="dangerText"
    :disabled="isDisabled"
  />
</template>

<script setup lang="ts">
import { BittsInput } from '@crossbeam/bitts';

import { useTemplateRef } from 'vue';

defineProps<{
  status?: 'danger';
  dangerText?: string;
  isDisabled?: boolean;
}>();

const proxyUrl = defineModel<string>({ required: true });

const input = useTemplateRef<InstanceType<typeof BittsInput>>('input');

function focus() {
  input.value?.focusInput();
}

defineExpose({ focus });
</script>

<style lang="pcss" scoped>
@reference "../../css/theme.css";
.c-salesforce-proxy-url-field {
  @apply w-full text-left;
}
</style>
